<template>
  <div class="welcome">
    <img alt="Mindful Reading Logo" src="../../public/favicon.png" />
    <h1 class="mt-15">Welcome to Mindful Reading</h1>
    <h3>
      <div class="text-center">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title style="white-space: normal;">
              Find interesting articles on the Internet
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title style="white-space: normal;">
              Add it to your custom RSS feed
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title style="white-space: normal;">
              Use your favorite RSS Feed reader to read it later
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title style="white-space: normal;">
              We load articles in readability view to make them more readable
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title style="white-space: normal;">
              Start reading where you last left (on the same device)
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="mt-15 text-center">
              <v-btn href="/login" color="primary" depressed>
                Login
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="mt-10">
          <v-list-item-content>
            <v-list-item-title style="white-space: normal;">
              Try out the amazing Mindful readability view
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-text-field
                v-model="contentURL"
                label="Enter a link here..."
                outlined
                clearable
                @keydown.enter="showReadablePage"
                v-validate="{ url: { require_protocol: false } }"
                data-vv-as="field"
                name="content_url"
                style="max-width: 800px;margin: auto;"
              ></v-text-field>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="mt-10">
          <v-list-item-content>
            <v-list-item-title>
              Try these:<br />
              <a
                target="_blank"
                href="/v1/readable/aHR0cHM6Ly93d3cucmFua3NjaWVuY2UuY29tL2Jsb2cvcGludGVyZXN0LWltYWdlLXNlby1ncm93dGgtaGFjaw=="
              >
                Rank Science </a
              ><br />
              <a
                target="_blank"
                href="/v1/readable/aHR0cHM6Ly93d3cudGhlZ3VhcmRpYW4uY29tL2NvbW1lbnRpc2ZyZWUvMjAyMC9kZWMvMjMvY3liZXItYXR0YWNrLXVzLXNlY3VyaXR5LXByb3RvY29scw=="
              >
                The Guardian </a
              ><br />
              <a
                target="_blank"
                href="/v1/readable/aHR0cHM6Ly93d3cudGhlYXRsYW50aWMuY29tL3BvbGl0aWNzL2FyY2hpdmUvMjAxNi8wNC9jYW5jZXItdGhlLWZpbmFsLWZyb250aWVyLzQ3ODk2Mi8="
              >
                Atlantic
              </a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </h3>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #c5a93b;
}
</style>

<script>
export default {
  data() {
    return {
      contentURL: ""
    };
  },
  methods: {
    showReadablePage: function() {
      if (!this.contentURL.startsWith("http")) {
        this.contentURL = "https://" + this.contentURL;
      }
      window.location = "/v3/r?url=" + this.contentURL;
    }
  }
};
</script>
